export const LEVEL_STYLES = {
  "Actes dangereux": { badge: "bg-rose-500/20 text-rose-700 border-rose-500/30", border: "border-rose-500/40", label: "Actes dangereux" },
  "Conditions préalables": { badge: "bg-amber-500/20 text-amber-700 border-amber-500/30", border: "border-amber-500/40", label: "Conditions préalables" },
  "Facteurs de supervision": { badge: "bg-pink-500/20 text-pink-700 border-pink-500/30", border: "border-pink-500/40", label: "Facteurs de supervision" },
  "Influences organisationnelles": { badge: "bg-indigo-500/20 text-indigo-700 border-indigo-500/30", border: "border-indigo-500/40", label: "Influences organisationnelles" },
};

export const LEVEL_ORDER = ["Actes dangereux", "Conditions préalables", "Facteurs de supervision", "Influences organisationnelles"];

export const FACTOR_STATUS_STYLES = {
  "À examiner": "bg-sky-500/15 text-sky-600 border-sky-500/30",
  "Retenu": "bg-emerald-500/20 text-emerald-700 border-emerald-500/40 font-semibold",
  "Rejeté": "bg-slate-100 text-slate-600 border-slate-300 line-through opacity-75",
};
